import { cn } from './cn';

/**
 * <EmptyState
 *   icon={<Inbox size={32} />}
 *   title="Sin cotizaciones"
 *   description="Aun no creaste ninguna cotizacion."
 *   action={<Button>Nueva</Button>}
 * />
 *
 * Para tablas vacias, busquedas sin resultados, etc.
 */
const EmptyState = ({ icon, title, description, action, className }) => (
    <div
        className={cn(
            'flex flex-col items-center justify-center text-center',
            'py-12 px-6',
            className
        )}
    >
        {icon && (
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-surface-2 text-muted mb-4">
                {icon}
            </div>
        )}
        {title && <h3 className="text-base font-semibold text-text">{title}</h3>}
        {description && (
            <p className="text-sm text-muted mt-1 max-w-sm">{description}</p>
        )}
        {action && <div className="mt-5">{action}</div>}
    </div>
);

export default EmptyState;
